import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/appCarDriver/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/appCarDriver/saveOrUpdate',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/appCarDriver/detail/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/appCarDriver/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/appCarDriver/' + id,
method: 'put',
data: obj
})
}
